export class Auth {

	ajaxAuth(parent) {
		let _this = this;
		$(parent).find('button').attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=sms_login',
			dataType: "json",
			success: function (res) {
				$(parent).find('button').attr('disabled', false);

				if (res['success']) {
					$("body").addClass("no-scroll");
					$('.popup-auth-code .popup-auth__card--phone_number').text(parent.str_phone.value);
					$('.popup-auth-code').addClass("active");
					_this.startTimer();
				}
				else {
					_this.showMistake(parent, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				$(parent).find('button').attr('disabled', false);
				_this.showMistake(parent, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	startTimer(type = 'sms') {
		/*
		let time;

		if (type == 'email') {
			parent = '.popup-auth-code__container--email'
			time = 29;
		}
		else if (type == 'flashcall') {
			parent = '.popup-auth-code__container--flashcall'
			time = 29;
		}
		else if (type == 'sms') {
			parent = '.popup-auth-code__form'
			time = 30;
		}*/
		let time = 30;
		if (this.intervalId)
		{
			clearInterval(this.intervalId);
		}

		$('.popup-auth-code__repeat').fadeIn();
		$('.popup-auth-code__repeat-btn').prop('disabled', true);
		$('.popup-auth-code__repeat span').show();
		$('.popup-auth-code__repeat span').text('  (через ' + time + ' сек)');
		this.intervalId = setInterval(function () {
			time--;
			$('.popup-auth-code__repeat span').text('  (через ' + time + ' сек)');
			if (time == 0) {
				clearInterval(this.intervalId);
				$('.popup-auth-code__repeat span').hide();
				$('.popup-auth-code__repeat-btn').prop('disabled', false);
			}
		}, 1000);
	}

	async regPhone(type = 'auto') {
		$('.popup-auth-tel .auth-form__submit').prop('disabled', true);
		let _this = this;

		let recpatchaSelector = document.querySelector('meta[name="captcha"]');
		let recaptchaToken = "";
		if (recpatchaSelector) {
			let recpatchaKey = recpatchaSelector.content;
			recaptchaToken = await grecaptcha.execute(recpatchaKey, { action: 'submit' });
		}

		$.ajax({
			url: "/ajax.php?mid=22",
			type: 'POST',
			data: {
				action: 'reg_phone',
				str_phone: $('.popup-auth-tel #auth-tel').val(),
				type: type,
				token: recaptchaToken,
			},
			dataType: "json",
			success: function (res) {
				if (res.success) {
					$('.popup-auth-tel').removeClass('active');
					$('.popup-auth-tel .form__mistakes').text('');

					if (type == 'sms') {
						_this.codePopup('sms');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						_this.startTimer('sms');
					}
					else if (res.email) {
						_this.codePopup('email');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						$('.popup-auth-code .founded_email').text(res.email);
						_this.startTimer('email');
					}
					else {
						_this.codePopup('flashcall');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						_this.startTimer('flashcall');
					}

					$('.popup-auth-tel .form__mistakes').text('');
					$('.popup-auth-tel .form__mistakes').hide();
				}
				else {
					$('.popup-auth-tel .form__mistakes').text(res.error);
					$('.popup-auth-tel .form__mistakes').show();
				}

				$('.popup-auth-tel .auth-form__submit').prop('disabled', false);
			},
			error: function (res) {
				$('.popup-auth-tel .auth-form__submit').prop('disabled', false);
				console.log(res);
			}
		});
	}

	submitCode(parent) {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=check_code',
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake(parent);
					location.reload();
				}
				else {
					_this.showMistake(parent, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				_this.showMistake(parent, 'Ошибка: ' + res);
				console.log(res);
			}
		});
	}

	submitCodeOrder(parent) {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=33",
			type: 'POST',
			data: $(parent).serialize() + '&action=check_code',
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake(parent);
					order.makeOrder($('form.order')[0]);
				}
				else {
					_this.showMistake(parent, 'Ошибка: ' + res['error']);
				}
			},
			error: function (res) {
				_this.showMistake(parent, 'Ошибка: ' + res);
				console.log(res);
			}
		});
	}

	regUser() {
		$('#reg_user_submit').prop('disabled', true);
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=7",
			type: 'POST',
			data: $('.auth__reg form').serialize() + '&action=reg_user',
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake('#reg_block');
					$('.auth__reg').hide();
					//$('#reg_step_3').fadeIn();
					if (res.get_bonus)
						location.replace('/cabinet/gifts/#show_gift_' + res.order_id);
					else
						location.replace('/');
				}
				else {
					_this.showMistake('.auth__reg', res.error);
				}
			},
			error: function (res) {
				$('#reg_user_submit').prop('disabled', false);
				console.log(res);
			}
		});
	}

	smsCodeInput(parent) {
		let code = $(parent).val();
		let digits = parseInt(code).toString().length;
		if (digits == 5) {
			$('#sms_code_submit').prop('disabled', false);
		}
		else {
			$('#sms_code_submit').prop('disabled', true);
		}
	}

	resetPass(parent) {
		let _this = this;
		let form = $(parent);
		let phone = form.find('input[name=str_phone]').val();
		form.find('input[type=submit]').prop('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=6",
			type: 'POST',
			data: { action: 'reset_pass', phone: phone },
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake(form);
					_this.hidePopup(form.closest('.popup'));
				}
				else {
					_this.showMistake(form, res.error);
				}
			},
			error: function (res) {
				form.find('input[type=submit]').prop('disabled', false);
				console.log(res);
			}
		});
	}

	showMistake(block, text) {
		$(block).find('.form__mistakes').text(text);
		$(block).find('.form__mistakes').show();
	}

	hideMistake(block) {
		$(block).find('.form__mistakes').text('');
		$(block).find('.form__mistakes').hide();
	}

	hidePopup(popup) {
		$("body").removeClass("no-scroll");
		popup.removeClass("active");
	}

	applyEvents() {
		let _this = this
		$('.header__login-form').submit(function () {
			_this.ajaxAuth();
			return false;
		});
	}

}

